import React from "react";
import { Grid, Typography, Paper, Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import stellaImg from "../asset/stella.png";
import lunaImg from "../asset/luna.png";
// Commented out until Meissa and Sidra add support for license generation
// import meissaImg from "../asset/meissa.png";
// import sidraImg from "../asset/sidra.png";

// Meissa and sidra have not support license generation yet

export type DeviceType = "stella" | "luna";
// export type DeviceType = "meissa" | "sidra" | "stella" | "luna";

const deviceImages: Record<DeviceType, string> = {
//   meissa: meissaImg,
//   sidra: sidraImg,
  stella: stellaImg,
  luna: lunaImg,
};

export const deviceNames: Record<keyof typeof deviceImages, string> = {
//   meissa: "Meissa OT",
//   sidra: "Sidra LEG",
  stella: "Stella BIO",
  luna: "Luna EMG",
};

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(2, 0),
  },
  devicePaper: {
    padding: theme.spacing(2),
    textAlign: "center",
    cursor: "pointer",
    border: `2px solid #ccc`,
    borderRadius: theme.shape.borderRadius,
    boxShadow: "none",
    transition: "all 0.2s",
    [theme.breakpoints.down("xs")]: {
      padding: theme.spacing(1),
    },
  },
  selected: {
    border: `3px solid #0095da`,
    background: "#e6f7ff",
    boxShadow: "0 0 10px #0095da55",
  },
  image: {
    width: 180,
    height: 180,
    objectFit: "contain",
    margin: "0 auto",
    [theme.breakpoints.down("xs")]: {
      width: 120,
      height: 120,
    },
  },
  label: {
    marginTop: theme.spacing(1),
    fontWeight: "bold",
    textTransform: "capitalize",
  },
}));

interface DeviceSelectorProps {
  onSelect: (device: DeviceType) => void;
  selectedDevice: DeviceType | null;
}

export const DeviceSelector: React.FC<DeviceSelectorProps> = ({ onSelect, selectedDevice }) => {
  const classes = useStyles();
  return (
    <Box className={classes.root} style={{ maxWidth: 500, margin: '0 auto' }}>
      <Typography variant="h6" align="center" style={{ fontWeight: "bold", marginBottom: 20, marginTop: 20 }}>
        Select the device for which you want to generate a license
      </Typography>
      <Grid container spacing={3} justifyContent="center">
        {Object.keys(deviceImages).map((device) => (
          <Grid item xs={6} key={device} style={{ display: "flex", justifyContent: "center" }}>
            <Paper
              className={
                selectedDevice === device
                  ? `${classes.devicePaper} ${classes.selected}`
                  : classes.devicePaper
              }
              elevation={selectedDevice === device ? 3 : 0}
              onClick={() => onSelect(device as DeviceType)}
            >
              <img
                src={deviceImages[device as DeviceType]}
                alt={device}
                className={classes.image}
              />
              <Typography className={classes.label}>{deviceNames[device as keyof typeof deviceNames]}</Typography>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
